"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cells = void 0;

var _style = _interopRequireDefault(require("styled-jsx/style"));

var React = _interopRequireWildcard(require("react"));

var Cells = function Cells(props) {
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "jsx-1391326189" + " " + "cells"
  }, props.children), React.createElement(_style["default"], {
    styleId: "1391326189",
    css: ".cells.jsx-1391326189>*{margin:20px 0;}.cells.jsx-1391326189{font-family:\"Source Sans Pro\",Helvetica Neue,Helvetica,sans-serif;font-size:16px;background-color:var(--theme-app-bg);color:var(--theme-app-fg);padding-bottom:10px;}"
  }));
};

exports.Cells = Cells;
Cells.defaultProps = {
  children: []
};